import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FlexBox from '../FlexBox'
import { HeaderMed } from '../Text'
import { FLEX_CENTER_CENTER } from '../../utils/styles'
import Icon from '../Icon'
import Color from '../../utils/color'

const CounterContainer = styled(FlexBox)`
  width: min-content;
  align-items: center;
`

const CounterButton = styled.div`
  color: ${Color.MudGrey};
  background: transparent;
  border: 1px solid ${Color.MudGrey};
  border-radius: 2px;
  height: 1.5rem;
  padding: 0 0.5rem;
  ${FLEX_CENTER_CENTER};

  &:disabled {
    opacity: 0.5;
  }
`

const CurrentValue = styled(HeaderMed)`
  padding: 0.5rem 1rem;
`

let timeout = null

function ItemCounter({
  value, onChange, max,
}) {
  const [pseudo, setPseudo] = useState(value)

  useEffect(() => {
    setPseudo(value)
  }, [])

  useEffect(() => {
    if (pseudo !== value) setPseudo(value)
  }, [value])

  // debounce onChange to avoid unnecessary requests
  useEffect(() => {
    if (timeout) clearTimeout(timeout)
    if (pseudo !== value) {
      // set deferred callback
      timeout = setTimeout(() => onChange(pseudo), 500)
    }
  }, [pseudo])

  function decrement() {
    if (pseudo > 0) setPseudo(pseudo - 1)
  }

  function increment() {
    setPseudo(pseudo + 1)
  }

  return (
    <CounterContainer>
      <CounterButton onClick={decrement}>
        {pseudo > 1 ? '-' : <Icon name="trash" />}
      </CounterButton>
      <CurrentValue>{pseudo}</CurrentValue>
      <CounterButton
        onClick={increment}
        disabled={!!max && pseudo >= max}
      >
          +
      </CounterButton>
    </CounterContainer>
  )
}

ItemCounter.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  max: PropTypes.number,
}

ItemCounter.defaultProps = {
  max: null,
}

export default ItemCounter
